module.exports = __webpack_public_path__ + "img/product1-4.da307158.png";